import React from "react";
import { motion } from "framer-motion";
import { SERVICES } from "../data/site";

export const Services = ({ onQuote }) => {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="py-24 lg:py-36 bg-[#F0EFEA]"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 lg:gap-12 mb-16">
                    <div className="col-span-12 lg:col-span-5">
                        <div className="overline text-[#4A4643] mb-6">
                            Services
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#1A1A1A]">
                            A complete<br />
                            <span className="italic text-[#8C7C6D]">studio practice.</span>
                        </h2>
                    </div>
                    <div className="col-span-12 lg:col-span-6 lg:col-start-7 flex items-end">
                        <p className="text-base lg:text-lg text-[#4A4643] leading-relaxed font-light max-w-lg">
                            We operate as your single design partner — from the first
                            site visit to the last cushion. Five focused disciplines,
                            one consistent point of view.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-0 border-t border-[#1A1A1A]/15">
                    {SERVICES.map((s, i) => (
                        <motion.div
                            key={s.no}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            data-testid={`service-card-${s.no}`}
                            className="group py-10 lg:py-12 border-b border-[#1A1A1A]/15 cursor-default"
                            onClick={onQuote}
                        >
                            <div className="overline text-[#8C7C6D]">{s.no}</div>
                            <h3 className="font-serif text-2xl lg:text-3xl mt-4 text-[#1A1A1A] font-medium tracking-tight">
                                {s.title}
                            </h3>
                            <p className="mt-4 text-[#4A4643] leading-relaxed text-[15px] font-light">
                                {s.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
